import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CtLookupItem } from '@ctsolution/ct-framework/lib/_containers/ct-model/lib/ct-backoffice/lookups.ct-backoffice';

/**
 * Service per il caricamento dei tipi di LeadInformation.
 * Legge il file JSON di configurazione `lead-information-type.json`
 * e mantiene una cache in-memory per evitare richieste HTTP ripetute.
 *
 * Analogo a `CompanyInformationService`.
 */
@Injectable()
export class LeadInformationFormService {

  private readonly dataUrl = `${window.location.origin}/assets/demo/lead-information-type.json`;

  /** Cache in-memory: valorizzata al primo caricamento, riutilizzata nelle chiamate successive. */
  private cachedData: CtLookupItem[] | null = null;

  constructor(private http: HttpClient) {}

  /**
   * Restituisce i tipi di LeadInformation disponibili.
   * Se i dati sono già in cache, non effettua una nuova richiesta HTTP.
   */
  getLeadInformationTypes(): Observable<CtLookupItem[]> {

    if (this.cachedData) {
      return of(this.cachedData);
    }

    return this.http
      .get<CtLookupItem[]>(this.dataUrl)
      .pipe(
        map(data => {
          this.cachedData = data;
          return data;
        }),
        catchError(error => {
          console.error('LeadInformationFormService: errore nel caricamento dei tipi:', error);
          return of([]);
        })
      );
  }

}
